import React, { useEffect, useState } from "react";
import { getAllCVs } from "../../../api/apiServices";
import Pagination from "../../../services/Pagination";
import Loader from "../../Common/Spinner/Loader";

export const CVManagement = () => {
	let [isLoading, setIsLoading] = useState(true);
	const [all_cvs, setAllCVs] = useState([]);

	const [currentPage, setCurrentPage] = useState(1);
	const [postPerPage, setPostPerPage] = useState(20);

	useEffect(() => {
		setIsLoading(true);
		getAllCVs().then((res) => {
			console.log(res)
			setIsLoading(false);
			setAllCVs(res);
		});
	}, []);

	console.log(all_cvs);
	const indexOfLastPage = currentPage * postPerPage;
	const indexOfFirstPage = indexOfLastPage - postPerPage;
	const currentPosts = all_cvs?.slice(indexOfFirstPage, indexOfLastPage);

	let content;
	if (isLoading) {
		content = (
			<div className="loader">
				<p>Loading CVs...</p>
				<Loader />
			</div>
		);
	} else {
		content = (
			<div className="table-responsive lg table-wrapper">
				<table className="table table-bordered table-hover table-striped">
					<thead className="align">
						<tr>
							<th scope="col">#</th>
							<th scope="col">PF Number</th>
							<th scope="col">Full Name</th>
							<th scope="col">Mobile Number</th>
							<th scope="col">Email</th>
							<th scope="col">Profession</th>
							<th scope="col">Action</th>
						</tr>
					</thead>
					<tbody>
						{currentPosts?.map((mem, index) => (
							<tr key={index}>
								<td>
									{postPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td>{mem.pf_number}</td>

								<td style={{ whiteSpace: "nowrap" }}>
									{mem.fullname.toUpperCase()}&nbsp;
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{mem.mobile_number}
								</td>
								<td>{mem.email}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{mem.profession}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									<div style={{ display: "inline-block" }}>
										<a
											rel="noreferrer"
											target="_blank"
											href={`/uploads/CVs/${mem.curriculum_vitae}`}
											className="small mr-3"
										>
											{" "}
											<i className="fa fa-eye"></i> View
											CV
										</a>
									</div>
									&nbsp;&nbsp;&nbsp;&nbsp; 
									<div style={{ display: "inline-block" }}>
										<a
											rel="noreferrer"
											target="_blank"
											download={`${mem.curriculum_vitae}`}
											href={`/uploads/CVs/${mem.curriculum_vitae}`}
											className="small mr-3"
										>
											{" "}
											<i className="fa fa-eye"></i>{" "}
											Download CV
										</a>
									</div>
									&nbsp; &nbsp;
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<section className="content-header">
				<h1>
					<i className="fas file"></i> Curriculum Vitae
				</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>Curriculum Vitae</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{content}</div>
							<div className="panel-footer">
								{all_cvs?.length > 0 &&
									!isLoading && (
										<Pagination
											data={all_cvs}
											postPerPage={postPerPage}
											currentPage={currentPage}
											setCurrentPage={setCurrentPage}
											setPostPerPage={setPostPerPage}
										/>
									)}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
